// TODO Add a couple lines about each project
const data = [
  {
    title: 'Oyster',
    image: '/images/art/oyster.jpg',
    desc:
      'Empty. Was tasty.',
  },
  {
    title: 'Magnolias',
    image: '/images/art/magnolias.jpg',
    desc:
      'Magnolias from Alexandria.',
  },
  {
    title: 'Grožnjan',
    image: '/images/art/groznjan.jpg',
    desc:
      'A square in Grožnjan, Croatia.',
  },
  {
    title: 'Petra, the lost city',
    image: '/images/art/petra.jpg',
    desc:
      'The Treasury at Petra, Jordan. '
      + 'The lost city was a major trading city during the operation of the Incense Route. '
      + 'After the Romans bypassed the taxes levied on the route, the Bedouins who inhabited '
      + 'the new defunct city left.',
  },
  {
    title: 'Study of a Woman',
    image: '/images/art/woman.jpg',
    desc:
      'Portrait Study.',
  },
  {
    title: 'Pine Forest',
    link: 'https://devpost.com/software/harvest',
    image: '/images/art/forest.jpg',
    desc:
      'Rough sketch of a misty forest in Japan.',
  },
];

export default data;
